// extracted by mini-css-extract-plugin
export default {"feedbackSum":"hyPFMA","mobile":"_D12rJ","feedbackRow":"fM0utt","ratingWrap":"XUNDyz","rating":"eo4uJC","fiveStarRate":"gJvI22"};